import { StrictMode, Suspense, lazy } from 'react';
import paynetConsoleLogMessage from './helpers/paynetConsoleMessage';
import ScreenLoader from './pages/ScreenLoader';
import ReactDOM from 'react-dom/client';
import './index.css';
const App = lazy(() => import('./App'));

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <Suspense fallback={<ScreenLoader />}>
      <App />
    </Suspense>
  </StrictMode>
);

paynetConsoleLogMessage();
